import { useEffect } from 'react'
import { MdChevronLeft, MdChevronRight } from 'react-icons/md'
import {
  Box,
  Button,
  Image,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  Stack,
  Text,
  useDisclosure
} from '~/design_system'
import { useAvaStore } from './state'

const Screen = ({ screen = {}, selectOption }) => (
  <>
    <Box mb="8" className="ava-screen-text">
      <Text fontSize="2xl" dangerouslySetInnerHTML={{ __html: screen.text }} />
      {screen.sub_text && <Text fontSize="xl" dangerouslySetInnerHTML={{ __html: screen.sub_text }} />}
    </Box>
    {screen.action_url ? (
      <Button href={screen.action_url}>{screen.action_text || screen.action_url}</Button>
    ) : (
      <Stack spacing="4">
        {screen?.screen_options?.map(option => (
          <Button
            key={option.id}
            variant="outline"
            boxShadow="sm"
            height="auto"
            w="100%"
            justifyContent="space-between"
            whiteSpace="normal"
            p="4"
            onClick={() => selectOption(option)}>
            <Box textAlign="left">
              <Text fontSize="2xl" my="0" fontWeight="bold">
                {option.text}
              </Text>
              {option.sub_text && (
                <Text my="0" display="block">
                  {option.sub_text}
                </Text>
              )}
            </Box>
            <Box as={MdChevronRight} fontSize="3xl" />
          </Button>
        ))}
      </Stack>
    )}
  </>
)

export const Ava = ({
  placement,
  openAvaButtonSelector,
  isOpen: controlledIsOpen,
  onOpen: controlledOnOpen,
  onClose: controlledOnClose
}) => {
  const uncontrolledDisclosureState = useDisclosure()
  const controlledDisclosureState = { isOpen: controlledIsOpen, onOpen: controlledOnOpen, onClose: controlledOnClose }
  const { isOpen, onOpen, onClose } = controlledIsOpen != null ? controlledDisclosureState : uncontrolledDisclosureState

  const { actions, currentScreen, showBackButton, currentImage } = useAvaStore()

  useEffect(() => {
    if (placement) actions.getByPlacement(placement)
  }, [])

  useEffect(() => {
    const avaButton = document.querySelector(openAvaButtonSelector)

    if (avaButton) avaButton.addEventListener('click', onOpen)

    return () => avaButton?.removeEventListener('click', onOpen)
  }, [openAvaButtonSelector])

  return (
    <Modal blockScrollOnMount={false} size="4xl" isCentered isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      {/* Chakra renders the modal way at the top, so the isChakra classname is needed again for several CSS properties */}
      <ModalContent className="isChakra" mx={8} borderRadius="md">
        <Box position="absolute" top="2" left="3">
          {showBackButton() && (
            <Button variant="link" mt={1} onClick={actions.previousScreen}>
              <Box as={MdChevronLeft} fontSize="2xl" />
              Previous
            </Button>
          )}
        </Box>
        <ModalCloseButton />
        <ModalBody mt="8" px="16" py="12">
          <Stack isInline spacing="4" align="center">
            <Box flex="1">
              <Image src={currentImage.image} alt={currentImage.alt} />
            </Box>
            <Box flex="3">
              <Screen screen={currentScreen} selectOption={actions.nextScreen} />
            </Box>
          </Stack>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}
